import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState('home');
  const [dropdownStates, setDropdownStates] = useState({
    platformFeatures: false,
    professionalServices: false,
  });

  const navigateTo = (view) => {
    setCurrentView(view);
    // Close all dropdowns
    setDropdownStates({
      platformFeatures: false,
      professionalServices: false,
    });
  };

  const toggleDropdown = (dropdownName) => {
    setDropdownStates(prev => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  const closeAllDropdowns = () => {
    setDropdownStates({
      platformFeatures: false,
      professionalServices: false,
    });
  };

  return (
    <NavigationContext.Provider
      value={{
        currentView,
        dropdownStates,
        navigateTo,
        toggleDropdown,
        closeAllDropdowns,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
